export default __webpack_public_path__ + "images/nz-4dedf09b8933ec6f43903ba10d865d56.svg";